import { useEffect, useSyncExternalStore } from 'react'
import { getRecoveryStatus, subscribeRecovery } from './recovery'

/** Verdadeiro quando há trabalho por gravar nesta sessão. */
export function useUnsavedWork(): boolean {
  return useSyncExternalStore(
    subscribeRecovery,
    () => getRecoveryStatus().dirty,
    () => false,
  )
}

/**
 * Aviso do browser ao sair/recarregar, e SÓ quando há trabalho por
 * gravar: numa app vazia (ou logo a seguir a "Guardar sessão") sair não
 * pergunta nada. O texto é do browser, não nosso; o `preventDefault` é
 * o que o standard pede desde 2023 (o `returnValue` fica por
 * compatibilidade com motores antigos).
 */
export function useUnsavedWorkGuard(): void {
  const dirty = useUnsavedWork()
  useEffect(() => {
    if (!dirty) return
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      e.returnValue = ''
      return ''
    }
    window.addEventListener('beforeunload', onBeforeUnload)
    return () => window.removeEventListener('beforeunload', onBeforeUnload)
  }, [dirty])
}
